import { faCircleNotch, faPhone } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as Style from "./CallingThreadStyle"
import { useCallContext } from "./CallContext"
import { DeclineCallIcon } from "."

export function CallingThread({ call, setIsOpen }) {
    const { activeCall, acceptingCall, rejectingCall, acceptIncomingCall, rejectIncomingCall } = useCallContext()

    const handleRejectCall = async () => {
      await rejectIncomingCall(call)
      setIsOpen(false)
    }

    const handleAcceptCall = async () => {
      await acceptIncomingCall(call)
      setIsOpen(false)
    }

    const isAccepting = () => {
        console.log("ACCEPTING CALL: ", acceptingCall)
        if (!acceptingCall) return false
        return acceptingCall.callId === call.callId
    }

    const isRejecting = () => {
        console.log("REJECTING CALL: ", rejectingCall)
        if (!rejectingCall) return false
        return rejectingCall.callId === call.callId
    }

    const isDisabled = () => {
        return isAccepting() || isRejecting() || acceptingCall || rejectingCall
    }

    const displayName = call?.from || "Unknown"
    const displayNumber = call?.from || "Unknown"

    return (
        <Style.Container>
            <Style.ContentWrapper>
                <FontAwesomeIcon icon={faPhone} />
                <Style.Content>
                    <div className="name">{displayName}</div>
                    <p className="number">{displayNumber}</p>
                </Style.Content>
            </Style.ContentWrapper>
            <Style.ActionButtonWrapper>
                <Style.ActionButton 
                    type="button" 
                    variant="reject" 
                    onClick={handleRejectCall}
                    disabled={isDisabled()}
                >
                    {!isRejecting() && <DeclineCallIcon size={18}/>}
                    {isRejecting() && <FontAwesomeIcon icon={faCircleNotch} spin />}
                </Style.ActionButton>
                <Style.ActionButton 
                    type="button" 
                    variant="accept" 
                    onClick={handleAcceptCall}
                    disabled={isDisabled() || activeCall?.callStatus === "ACCEPTED"}
                >
                    {!isAccepting() && <FontAwesomeIcon icon={faPhone} />}
                    {isAccepting() && <FontAwesomeIcon icon={faCircleNotch} spin />}
                </Style.ActionButton>
            </Style.ActionButtonWrapper>
        </Style.Container>
    )
}
